export const AirFreightZh = {
  // 中文
  DataStatistics: '数据统计',
  CurrentMonth: '当月度',
  CurrentQuarter: '当季度',
  CurrentYear: '当年度',
  ServiceType: '运输模式',
  AirFreightExport: '空运出口',
  AirFreightImport: '空运进口',
  TotalBLofShipment: '总票数',
  BLofShipmentGeneralCargo: '票数（普货）',
  BLofShipmentHazmatCargo: '票数（危险品）',
  WeightGeneralCargoKGS: '普货货重(KGS)',
  WeightHazmatCargoKGS: '危险品货重(KGS)',
  ShipmentStatistics: '票数统计',
  BLofShipment: '票数',
  TotalWeight: '总货重',
  Total: '总货重',
  WeightStatistics: '货重统计',
  WeightKGS: '货重(KGS)',
  WeightGeneralCargo: '普货货重',
  WeightHazmatCargo: '危险品货重',
  BookingQuery: '订单查询',
  SubscriptionCenter: '订阅中心',
  JobNo: '我司编码',
  PleaseFillinContents: '请输入内容',
  RangeofBooking: '下单区间',
  AirWaybillExpressWaybill: '运单号/快件号',
  ShipmentStatus: '运单状态',
  Operation: '操作',
  CustomerCode: '客户编码',
  Query: '查询',
  Reset: '重置',
  Export: '导出',
  ViewDetails: '明细查看',
  MWJobNo: '业务编号',
  BookingDate: '下单日期',
  Collapse: '收起',
  PortofOriginDetails: '起运地信息',
  PortofDestinationDetails: '目的地信息',
  DownloadAttachment: '下载附件',
  FileName: '文件名',
  Creator: '创建人',
  CreationTime: '创建时间',
  Process: '操作',
  Download: '下载',
  Cancel: '取消',
  PortofOrigin: '起运地',
  PortofDestination: '目的地',
  TotalPackage: '总件数',
  PuttinginwarehouseTime: '入库时间',
  TimeofDeparture: '起飞时间',
  TimeofArrival: '到达时间',
  Other: '其他',
  SBookingReceipt: '接单',
  SBeginDt: '到港',
  SCustomsReleased: '放行',
  SpoDupload: '签收',
  AEDetails: '空运_空运出口',
  AIDetails: '空运_空运进口',
  StartDate: '开始日期',
  EndDate: '结束日期',
  CustomsNumber: '报关票数',
  TransportNumber: '运输票数',
  AINumber: '进口票数',
  SerialNumber: '序号',
  Switch: '切换',
  Code: '编码',
  Name: '名称',
  airport: 'airportName',
}

// 国际空运
export const AirFreightEn = {
  // 英文
  DataStatistics: 'Dashboard',
  CurrentMonth: 'Current Month',
  CurrentQuarter: 'Current Quarter',
  CurrentYear: 'Current Year',
  ServiceType: 'Category',
  AirFreightExport: 'Air Export',
  AirFreightImport: 'Air Import',
  TotalBLofShipment: 'Total',
  BLofShipmentGeneralCargo: 'NDG',
  BLofShipmentHazmatCargo: 'DG',
  WeightGeneralCargoKGS: 'Weight of NDG (KGS)',
  WeightHazmatCargoKGS: 'Weight of DG (KGS)',
  ShipmentStatistics: 'Shipment',
  BLofShipment: 'B/L of Shipment',
  TotalWeight: 'Total WT',
  Total: 'Total',
  WeightStatistics: 'Volume',
  WeightKGS: 'Weight (KGS)',
  WeightGeneralCargo: 'NDG',
  WeightHazmatCargo: 'DG',
  BookingQuery: 'Tracking',
  SubscriptionCenter: 'Subscription',
  JobNo: 'MW No.',
  PleaseFillinContents: 'Please fill in the contents',
  RangeofBooking: 'Booking Date',
  AirWaybillExpressWaybill: 'MAWB/Express No',
  ShipmentStatus: 'Status',
  Operation: 'ATT',
  CustomerCode: 'Your Ref No.',
  Query: 'Search',
  Reset: 'Reset',
  Export: 'Export',
  ViewDetails: 'Details',
  MWJobNo: 'MW Job No#',
  BookingDate: 'Booking Date',
  Collapse: 'Collapse',
  PortofOriginDetails: 'Port of Origin',
  PortofDestinationDetails: 'Port of Destination',
  DownloadAttachment: 'Download',
  FileName: 'File Name',
  Creator: 'Creator',
  CreationTime: 'Creation Time',
  Process: 'Process',
  Download: 'Download',
  Cancel: 'Cancel',
  PortofOrigin: 'Origin',
  PortofDestination: 'Destination',
  TotalPackage: 'Total PKG',
  PuttinginwarehouseTime: 'Inbound Date',
  TimeofDeparture: 'ETD',
  TimeofArrival: 'ETA',
  Other: 'Other',
  SBookingReceipt: 'Booking Receipt',
  SBeginDt: 'ATD',
  SCustomsReleased: 'Customs Released',
  SpoDupload: 'POD',
  AEDetails: 'AirFreight_AirExport',
  AIDetails: 'AirFreight_AirImport',
  StartDate: 'Start Date',
  EndDate: 'End Date',
  CustomsNumber: 'Total customs declarations',
  TransportNumber: 'Total Transport',
  AINumber: 'Air import votes',
  SerialNumber: 'No',
  Switch: 'Switch',
  Code: 'Code',
  Name: 'Name',
  airport: 'airportEname',
}




